import { queryOptions } from '@tanstack/react-query';
import { getReviewStatistics } from '~/apis/review';

/** 메루카리 상품상세 조회를 위한 쿼리 옵션 */

export const reviewStatisticsOptions = (uid: number) => {
  const options = queryOptions({
    queryKey: ['product', 'getReviewStatistics', uid],
    queryFn: () => getReviewStatistics(uid),
    select: (response) => response.data,
    enabled: Boolean(uid),
    retry: 0,
  });

  return options;
};
